/*
 * @description:
 * @param:
 * @return:
 */
import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式

const whiteList = ['/login', '/actormgr/ActorList'] // 不重定向白名单
router.beforeEach(async (to, from, next) => {
  // 菜单
  if (localStorage.getItem('auths_kissu')) {
    let auths = JSON.parse(localStorage.getItem('auths_kissu'))
    store.state.auths = auths

  }
  if (localStorage.getItem('channels_kissu')) {
    // 更新渠道号
    let channels = JSON.parse(localStorage.getItem('channels_kissu'))
    store.state.channels = channels
  }
  if (window.$cookies.get('username_kissu')) {
    // 更新渠道号
    let username = window.$cookies.get('username_kissu')
    store.state.username = username
  }


  NProgress.start()
  if (window.$cookies.get('token_kissu')) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.state.auths.length == 0) {
        next()
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
